import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Progress } from "@/components/ui/progress";
import { Loader2 } from "lucide-react";

const ImportProgressDialog = ({ 
  isOpen, 
  progress, 
  totalRecords, 
  processedRecords,
  successCount,
  failureCount 
}) => {
  const percentage = totalRecords > 0 ? Math.round((processedRecords / totalRecords) * 100) : 0;

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Importing Teachers</DialogTitle>
        </DialogHeader>
        <div className="py-6 space-y-4">
          <div className="flex items-center justify-center">
            <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
          </div>
          
          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Progress</span>
              <span className="font-medium text-gray-900">{percentage}%</span>
            </div>
            <Progress value={percentage} className="h-2" />
          </div>

          <div className="grid grid-cols-2 gap-4 pt-2">
            <div className="space-y-1">
              <p className="text-xs text-gray-500">Total Records</p>
              <p className="text-lg font-semibold text-gray-900">{totalRecords}</p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-gray-500">Processed</p>
              <p className="text-lg font-semibold text-blue-600">{processedRecords} / {totalRecords}</p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-gray-500">Successful</p>
              <p className="text-lg font-semibold text-green-600">{successCount}</p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-gray-500">Failed</p>
              <p className="text-lg font-semibold text-red-600">{failureCount}</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImportProgressDialog;
